import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import AveragesStage, { AveragesStageParams } from '../stages/transformations/AveragesStage';

export type AveragesParams = BlockParameters & AveragesStageParams;

@AddMetadata({
    type: BlockKeys.Averages,
    name: 'Averages',
    description: 'Transform given sensor datas (global, by level, by column) in the average or median value',
})
class AveragesBlock extends PipelineBlock<AveragesParams> {
    constructor(params: AveragesParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new AveragesStage(this.getParams())];
    }
}

export default AveragesBlock;
